<template>
  <main-layout>
    <group-detail-container />
  </main-layout>
</template>

<script>

import GroupDetailContainer from '@/components/Widgets/GroupDetailContainer';

export default {

  name: 'StylistGroup',
  components: {
    GroupDetailContainer,
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
</style>
